import Search from './Search';
import QRSortMenu from './QRSortMenu';
import { useNavigate } from 'react-router-dom';
import styles from './SearchFilterSort.module.css';

export default function SearchFilterSort(props) {

    const { filters, setFilters } = props;
    const navigate = useNavigate();

    const handleSearchType = (type) => {
        setFilters(prev => {
            return {
                ...prev,
                searchValue: '',
                searchType: type
            };
        });
    };

    const handleSearchValue = (e) => {
        e.preventDefault();

        setFilters(prev => {
            return {
                ...prev,
                searchValue: e.target.value
            };
        });
    };

    const handleRemoveSonar = () => {
        setFilters({
            sortBy: '',
            searchType: 'name',
            searchValue: '',
            categoryValue: ''
        });
        navigate('/collection');
    };

    return (
        <div className={styles.container} >
            {(filters?.searchType === 'name' || filters?.searchType === 'tag') ?
                <div className={styles.inputGroupTop}>
                    <input type='text' id='search-filter-sort' className={styles.input} value={filters?.searchValue} onChange={handleSearchValue} ></input>
                    <label htmlFor='search-filter-sort' className={styles.label}>{filters?.searchType === 'name' ? 'Name' : 'Tag'}</label>
                    <Search searchType={filters?.searchType} handleSearchType={handleSearchType} />
                </div>
            : filters?.searchType === 'sonar' ?
                <button className={styles.sonar} onClick={handleRemoveSonar}>Return to all QRs</button>
            : 
                <></>
            }
            <QRSortMenu filters={filters} setFilters={setFilters} />
        </div>
    )
}